import { Reducer } from 'redux';
import { update } from '../helpers/immutabilityHelper'
import * as Dtos from '../dtos/Tmd.dtos';

import {
    ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION,
    ACTION_PATIENT_LOAD_FAILURE,
    ACTION_PATIENT_LOAD_SUCCESS,

    ACTION_PATIENT_CLEAR,

    PatientAction
} from '../actions/patients';
import { RequestState } from "../enumerations/RequestState";
import { IRequestState } from "./index";


export interface IPatientState {
    data: Dtos.Patient | Dtos.Patient[],
    loadState: IRequestState;
}

const initialState: IPatientState = {
    data: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
};


function loading(state: IPatientState, _isLoading: boolean): IPatientState {
    const newState: IPatientState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(
    state: IPatientState,
    data: Dtos.Patient | Dtos.Patient[],
    responseStatus: Dtos.ResponseStatus
): IPatientState {
    const newState: IPatientState = update(state, {
        data: {
            $set: data
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: IPatientState, responseStatus: Dtos.ResponseStatus): IPatientState {
    const newState: IPatientState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IPatientState, propertiesToClear?: string[]): IPatientState {

    if (!propertiesToClear) {
        const newState: IPatientState = update(initialState, {});
        return newState;
    }

    let stateModifier: any = {};

    propertiesToClear.forEach(propertyToClear => {
        stateModifier[propertyToClear] = { $set: initialState[propertyToClear] }
    });

    const newState = update(state, stateModifier);

    return newState;
}

const PatientReducer: Reducer<IPatientState> = (state: IPatientState = initialState, action: PatientAction) => {
    switch (action.type) {
        case ACTION_PATIENT_LOAD_BY_TRIALINSTITUTION:
            return loading(state, true);
        case ACTION_PATIENT_LOAD_SUCCESS:
            return loadSuccess(state, action.data, action.responseStatus);
        case ACTION_PATIENT_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_PATIENT_CLEAR:
            return clear(state, action.propertiesToClear);
    }

    return state;
}

export default PatientReducer;